import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';

import imgDownArrow from 'src/assets/images/down-arrow-black.svg';

const Tab = ({ index, handleIndex, current, title }) => (
  <Root onClick={() => handleIndex(index)} current={current}>
    {title}
  </Root>
);

export default Tab;

Tab.propTypes = {
  index: PropTypes.number,
  handleIndex: PropTypes.func,
  current: PropTypes.bool,
  title: PropTypes.string,
};

const Root = styled.h2`
  color: ${props => (props.current ? props.theme.colorPrimary : '#DEDFE0')};
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fontHeader};
  font-weight: 500;
  transition: 0.3s ease;
  cursor: pointer;
  padding: 15px 0 15px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: ${media.smup}) {
    justify-content: flex-start;
    text-align: left;
    span {
      display: none;
    }
  }
  &:hover {
    color: ${({ theme }) => theme.colorPrimary};
  }
  &::after {
    content: '';
    background-image: url(${imgDownArrow});
    background-size: cover;
    width: 16px;
    height: 8px;
    display: inline-block;
    margin-left: 10px;
    transform: ${props => (props.current ? 'rotate(0)' : 'rotate(-90deg)')};
    transition: 0.2s ease;
    color: black;
    @media (min-width: ${media.smup}) {
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/TabContent/elements/Tab.js